import { render, staticRenderFns } from "./MenuTable.vue?vue&type=template&id=31ee2f1a"
import script from "./MenuTable.vue?vue&type=script&lang=ts"
export * from "./MenuTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports